module.exports = __webpack_public_path__ + "img/Jarvis_Logo@2x.71f76f63.png";